/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/RemoveSignatureAction/Content/Content/ConfirmAction",
  onSubmit,
  isSubmitting
  
}) {
let removeSignatureSubmitData = fromData.useDataSubmit({ viewPath,
context: 'remove_signature',
})
let removeSignatureIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'remove_signature',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 size="normal"
 type="primary"
 data="remove_signature"
 onClick={removeSignatureSubmitData}
 disabled={removeSignatureIsSubmittingData}
 text="Confirm"
/>
{children}
</React.Fragment>)
}